import { TrendingDown, TrendingUp } from "lucide-react";
import { computeMargin, marginTone } from "@/lib/margin";
import { useMarginPreference } from "@/lib/marginPreference";

/**
 * Pill mostrato nel ProductCard/Row quando il prodotto ha sia cost che price.
 * Esempio: "+35%" (verde), "+5%" (rosso), "-12%" (rosso scuro).
 *
 * Rispetta la preferenza utente `show_margin` (Impostazioni → Margine):
 * se disattivata, il pill non viene renderizzato in nessuna pagina.
 */
export default function MarginPill({ product, size = "sm", className = "" }) {
  const show = useMarginPreference();
  const m = computeMargin(product);
  if (!show || !m) return null;
  const tone = marginTone(m.pct);
  const Icon = m.pct >= 0 ? TrendingUp : TrendingDown;
  const base = size === "xs" ? "text-[10px] px-1.5 py-0.5 gap-1" : "text-xs px-2 py-0.5 gap-1";
  return (
    <span
      data-testid={`margin-pill-${product.id}`}
      title={`Margine: €${m.absolute.toFixed(2)} (vendita €${m.sell.toFixed(2)} − acquisto €${m.cost.toFixed(2)})`}
      className={`inline-flex items-center font-semibold rounded-md border ${tone.cls} ${base} ${className}`}
    >
      <Icon size={size === "xs" ? 9 : 11} />
      {m.pct >= 0 ? "+" : ""}{m.pct}%
    </span>
  );
}
